import PlatformActions from './PlatformActions'

export default class PPLIVEActions extends PlatformActions {
  constructor(formData) {
    super(formData)
    this.formData = formData

    this.constantTxnData = {
      gameType: 'LIVE',
      gameCode: 'PP-LIVE-001',
      platform: 'PP',
    }

    this.gameName = 'Baccarat 1'
  }

  getBetMessage(txnList) {
    const { currency, supportPremium } = this.formData

    const txns = txnList.map(({
      userId,
      txnId,
      roundId,
      betTime,
      betAmount,
      betDesc,
    }) => ({
      ...this.constantTxnData,
      gameName: this.gameName,
      userId,
      platformTxId: txnId, // 62ce77fb8295d61dbaa69ae3
      roundId: `${roundId}`, // 41065002008
      betType: null,
      currency,
      betTime, // 2022-07-13T15:44:59.808+08:00
      betAmount,
      jackpotBetAmount: 0,
      gameInfo: {
        'roundDetails-bet': `type:bets,desc:[{"c":"${betDesc}","a":"${betAmount}"}]`,
        isBuyFreeSpin: false,
      },
      ...(supportPremium && { isPremium: false }),
    }))

    const message = {
      action: 'bet',
      txns,
    }

    return JSON.stringify(message)
  }

  getSettleMessage(txnList) {
    const txns = txnList.map(({
      userId,
      roundId,
      updateTime,
      betTime,
      turnover,
      betAmount,
      winAmount,
      betInfos,
      roundDetails_settle, // eslint-disable-line camelcase
    }) => ({
      ...this.constantTxnData,
      gameName: this.gameName,
      userId,
      platformTxId: `${roundId}`, // 41065002008
      refPlatformTxId: null,
      settleType: 'roundId',
      updateTime, // 2022-07-13T15:45:12.556+08:00
      roundId: `${roundId}`, // 41065002008
      betType: null,
      betTime,
      txTime: betTime,
      turnover,
      betAmount,
      winAmount,
      jackpotWinAmount: 0,
      gameInfo: {
        betInfos,
        'roundDetails-settle': roundDetails_settle,
      },
    }))

    const message = {
      action: 'settle',
      txns,
    }

    return JSON.stringify(message)
  }

  getResettleMessage(txnList) {
    const txns = txnList.map(({
      userId,
      roundId,
      updateTime,
      betTime,
      turnover,
      betAmount,
      winAmount,
      resettleTime,
    }) => ({
      ...this.constantTxnData,
      gameName: this.gameName,
      userId,
      platformTxId: `${roundId}`, // 41065002008
      refPlatformTxId: null,
      settleType: 'roundId',
      updateTime, // 2022-07-13T15:45:12.556+08:00
      roundId: `${roundId}`, // 41065002008
      betType: null,
      betTime,
      txTime: betTime,
      turnover,
      betAmount,
      winAmount,
      gameInfo: {
        resettleTime,
      },
    }))

    const message = {
      action: 'resettle',
      txns,
    }

    return JSON.stringify(message)
  }

  getCancelBetMessage(txnList) {
    const txns = txnList.map(({
      userId,
      txnId,
      roundId,
    }) => ({
      ...this.constantTxnData,
      userId,
      platformTxId: txnId, // 62ce77fb8295d61dbaa69ae3
      roundId: `${roundId}`,
    }))

    const message = {
      action: 'cancelBet',
      txns,
    }

    return JSON.stringify(message)
  }
}
